import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { getMyService, putMyService } from '../lib/api';

/**
 * VEVOSZOLGALATI BEALLITAS a kliensen (docs/20-vevoszolgalat.html).
 *
 * A KESZ ertek (felhasznalo > ceg > globalis, a kotelezo szintekkel) a szerveren
 * oldodik fel, itt csak olvassuk. A ceg- vagy a globalis szint valtozasat az app a
 * kovetkezo betoltesnel / ablak-visszaterteskor latja (nincs ra valos ideju kereT).
 */

export const serviceKey = ['service', 'me'] as const;

export function useServiceSettings() {
  return useQuery({
    queryKey: serviceKey,
    queryFn: () => getMyService().then((result) => result.status),
    staleTime: 60_000,
    // Egy admin-valtoztatas akkor erjen el, amikor a kolléga visszater az ablakhoz.
    refetchOnWindowFocus: true,
  });
}

export function useUpdateMyService() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: putMyService,
    onSuccess: (result) => queryClient.setQueryData(serviceKey, result.status),
  });
}

/**
 * Tamogatja-e ez a bongeszo a lebego ablakot (Document Picture-in-Picture)?
 * Csak asztali Chrome/Edge - Firefoxban es Safariban nincs.
 */
export function pipSupported(): boolean {
  return typeof window !== 'undefined' && 'documentPictureInPicture' in window;
}
